var numOfSlides = document.querySelectorAll(".swiper-slide").length;

if ((window.innerWidth >= 750 && numOfSlides > 3) || (window.innerWidth < 750 && numOfSlides > 1)) {
  const swiper = new Swiper('.sizebarSlide', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      lazy: true,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 26,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        990: {
          slidesPerView: 2,
          centeredSlides: false
        },
        1200: {
          slidesPerView: 3,
          centeredSlides: false
        } 
      }
  });
} else {
  document.querySelector(".sizebarSlide").parentNode.classList.add("no-swiper")
}

document.querySelectorAll(".suot-sizebar__content summary").forEach((summary) => {
  summary.addEventListener("click", (event) => {
      event.currentTarget.closest('details').hasAttribute('open') ? event.currentTarget.closest('details').classList.remove("open") : event.currentTarget.closest('details').classList.add("open")
      if (event.currentTarget.closest('details').classList.contains("content__form--details")) {
        document.querySelectorAll(".content__form--details").forEach((detail) => {
          if (detail != event.currentTarget.closest('details') && detail.hasAttribute("open")) detail.removeAttribute("open")
        })
      }
  })
})

// Show mobile - tablet - desktop
if (window.matchMedia("(min-width: 1700px)").matches) {
  document.querySelector(".content__form--laptop").setAttribute("open", "");
} else if (window.matchMedia("(min-width: 1200px)").matches) {
  document.querySelector(".content__form--laptop").setAttribute("open", "");
} else if (window.matchMedia("(min-width: 727px)").matches) {
  document.querySelector(".content__form--tablet").setAttribute("open", "");
} else {
  document.querySelector(".content__form--mobile").setAttribute("open", "");
}

// Calculate svg first sizes
document.querySelectorAll(".suot-sizebar__slider--content .media-image").forEach(function(el) {
  const mm = el.dataset.mm;
  size = mm * 1.261437;
  el.querySelector("svg").setAttribute("width", size + "mm");
  el.querySelector("svg").setAttribute("height", "100%");
})

// Calculate ppi
function calcScreenPPI(screenInches) {
  const width = screen.width;
  const height = screen.height;

  const  ppi = Math.sqrt(width*width + height*height)/screenInches;

  return ppi;
}

function inchesFromMillimeter(millimeters) {
    return (1/25.4) * millimeters;
}

function calcRingSize(ppi) {
  document.querySelectorAll(".suot-sizebar__slider--content .media-image").forEach(function(el) {
    const mm = el.dataset.mm;
    let size = ppi * inchesFromMillimeter(mm); 
    size = size * 1.261437;
    el.querySelector("svg").style.width = size + "px";
    el.querySelector("svg").style.height = "auto";
  })
}

document.querySelector(".suot-sizebar__content--form").addEventListener("click", (event) => {
  if (event.target.classList.contains("card-radio--circle")) {
    if(event.target.previousElementSibling.dataset.inches != "none") {
      let ppi = calcScreenPPI(event.target.previousElementSibling.dataset.inches);
      calcRingSize(ppi);
      document.querySelectorAll(".card-text").forEach((text) => {
        if(!text.classList.contains("hidden")) text.classList.add("hidden")
        text.innerHtml = "";
        text.value = "";
      })
      setTimeout(closeDetails, 200);
    } else {
      let otherId = event.target.getAttribute("for");
      document.querySelector(`.card-text[data-id='${otherId}']`).classList.remove("hidden");
    }
  }
})

document.querySelectorAll(".suot-sizebar__content--form .card-text input").forEach((input) => {
  input.addEventListener("input", updateValue)
})

function updateValue(e) {
  let ppi = calcScreenPPI(e.srcElement.value);
  calcRingSize(ppi);
}

document.querySelectorAll(".suot-sizebar__content--form .card-text button").forEach((button) => {
  button.addEventListener("click", function() {
    setTimeout(closeDetails, 200)
  })
})

document.body.addEventListener("keydown", (e) => {
  if (e.code == "Enter" && document.querySelector(".suot-sizebar__calculate--container").classList.contains("open")) {
    setTimeout(closeDetails, 200);
  }
})

//Save Values
function saveInches() {
  //Radiobuttons  
  var g1 = document.querySelector('input.multi-product-check:checked');
  if (g1) {
    var g1Id = g1.id;
    var g1Inches = g1.dataset.inches;
    var c1Value = null;
    if (g1Inches == "none") {
      localStorage.setItem("g1", g1Id);
      if (document.querySelector(`.card-text[data-id='${g1Id}'] input`)) {
        var c1Value = document.querySelector(`.card-text[data-id='${g1Id}'] input`).value;
        localStorage.setItem("c1", c1Value)
      } else {
        localStorage.setItem("c1", c1Value)
      }
    } else {
      localStorage.setItem("g1", g1Id);
      localStorage.setItem("c1", c1Value)
    }
  }
}

function closeDetails() {
    saveInches();
    document.querySelector(".suot-sizebar__calculate--container").classList.remove("open")
    document.querySelector(".suot-sizebar__calculate--container[open]").removeAttribute("open")
}

document.addEventListener('DOMContentLoaded', (event) => {
  var inputChecked = localStorage.getItem('g1');
  if (localStorage.getItem('g1') !== null) {
    document.getElementById(inputChecked).checked = true;
    if (localStorage.getItem('c1') != null && localStorage.getItem('c1') != "null") {
      var cardText = document.querySelector(`.card-text[data-id='${localStorage.getItem('g1')}']`);
      cardText.querySelector("input").value = localStorage.getItem('c1');
      let ppi = calcScreenPPI(localStorage.getItem('c1'));
      calcRingSize(ppi);
      cardText.querySelector("button").click;
    } else {
      let ppi = calcScreenPPI(document.getElementById(inputChecked).dataset.inches);
      calcRingSize(ppi);
    }
  }
});
